import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FeaturedContentBlock from 'app/components/shared/FeaturedContentBlock';
import { featuredContentShape } from '@bibliocommons/bc-prop-types';
import './RecommendedFeaturedContent.scss';

export class RecommendedFeaturedContent extends React.PureComponent {
  getContainerName() {
    const { libraryShortName } = this.props;
    return `Recommended by ${libraryShortName}`;
  }

  render() {
    const { libraryShortName, content } = this.props;

    if (content.isEmpty()) {
      return null;
    }

    return (
      <div className="cp-recommended-featured-content">
        <h3 className="content-recommended-by">
          <FormattedMessage id="related_resources" values={{ library_short_name: libraryShortName }} />
        </h3>
        <div className="content-container">
          {content.entrySeq().map(([contentType, contentList]) => (
            <FeaturedContentBlock
              containerName={this.getContainerName()}
              key={contentType}
              list={contentList}
              type={contentType}
              twoColumns={content.size === 1}
            />
          ))}
        </div>
      </div>
    );
  }
}

RecommendedFeaturedContent.propTypes = {
  libraryShortName: PropTypes.string.isRequired,
  content: ImmutablePropTypes.mapContains({
    BLOG_POST: ImmutablePropTypes.listOf(featuredContentShape),
    RESOURCE: ImmutablePropTypes.listOf(featuredContentShape),
    EVENT: ImmutablePropTypes.listOf(featuredContentShape)
  })
};

export default RecommendedFeaturedContent;
